﻿

	 import { SearchFilter } from '@models/search-filters/SearchFilter';
    
    export class EntityEventsSearchFilter extends SearchFilter {
        
        
        eventId?: number | null;
    }
